var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amap-wrapper"},[_c('div',{staticClass:"press_btn",style:({ width: _vm.press_width, height: _vm.press_height, paddingLeft: _vm.press_padding_left, 
      paddingRight: _vm.press_padding_right, paddingTop: _vm.press_padding_top, 
      paddingBottom: _vm.press_padding_bottom,marginLeft: _vm.press_margin_left, 
      marginRight: _vm.press_margin_right, marginTop: _vm.press_margin_top, 
      marginBottom: _vm.press_margin_bottom,background:_vm.longPressActive?_vm.press_active_bg:_vm.press_bg}),attrs:{"id":'press' + _vm.press_create_time},on:{"mousedown":_vm.handleDown,"mouseup":_vm.handleUp}},[_vm._v(" "+_vm._s(_vm.press_text||'按钮')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }